import {
  parseAdminCommercialContractResponse,
  parseAdminContractCancellationCreateRequest,
  parseAdminContractCancellationCreateResponse,
  parseAdminContractCancellationPreviewResponse,
  parseContractEmailChangeCreateResponse,
  parseContractEmailChangeRequest,
  parsePublicContractEmailChangeConfirmRequest,
  parsePublicContractEmailChangeConfirmResponse,
  parsePublicContractEmailChangeResolveRequest,
  parsePublicContractEmailChangeResolveResponse,
  parsePublicContractCancellationConfirmRequest,
  parsePublicContractCancellationConfirmResponse,
  parsePublicContractCancellationResolveRequest,
  parsePublicContractCancellationResolveResponse
  ,parseAdminContractCancellationRevocationCreateRequest
  ,parseAdminContractCancellationRevocationCreateResponse
  ,parseAdminContractCancellationRevocationPreviewResponse
  ,parsePublicContractCancellationRevocationConfirmRequest
  ,parsePublicContractCancellationRevocationConfirmResponse
  ,parsePublicContractCancellationRevocationResolveRequest
  ,parsePublicContractCancellationRevocationResolveResponse
} from "@madamuh/domain";
import type {
  AdminCommercialContractResponseDto,
  ContractEmailChangeCreateResponseDto,
  ContractEmailChangeRequestDto,
  PublicContractEmailChangeConfirmResponseDto,
  PublicContractEmailChangeResolveResponseDto,
  AdminContractCancellationCreateRequestDto,
  AdminContractCancellationCreateResponseDto,
  AdminContractCancellationPreviewDto,
  PublicContractCancellationConfirmResponseDto,
  PublicContractCancellationResolveResponseDto
  ,AdminContractCancellationRevocationCreateRequestDto
  ,AdminContractCancellationRevocationCreateResponseDto
  ,AdminContractCancellationRevocationPreviewDto
  ,PublicContractCancellationRevocationConfirmResponseDto
  ,PublicContractCancellationRevocationResolveResponseDto
} from "@madamuh/domain";
import { apiGet, apiPost } from "./client";

export async function fetchAdminCommercialContract(
  tenantSlug: string
): Promise<AdminCommercialContractResponseDto> {
  const response = await apiGet<unknown>(`/api/v1/admin/tenants/${tenantSlug}/commercial-contract`);
  return parseAdminCommercialContractResponse(response);
}

export async function previewAdminContractCancellation(tenantSlug: string): Promise<AdminContractCancellationPreviewDto> {
  return parseAdminContractCancellationPreviewResponse(await apiPost<Record<string, never>, unknown>(`/api/v1/admin/tenants/${tenantSlug}/contract-cancellations/preview`, {}));
}

export async function requestAdminContractCancellation(tenantSlug: string, request: AdminContractCancellationCreateRequestDto): Promise<AdminContractCancellationCreateResponseDto> {
  return parseAdminContractCancellationCreateResponse(await apiPost(`/api/v1/admin/tenants/${tenantSlug}/contract-cancellations`, parseAdminContractCancellationCreateRequest(request)));
}

export async function resolvePublicContractCancellation(token: string): Promise<PublicContractCancellationResolveResponseDto> {
  return parsePublicContractCancellationResolveResponse(await apiPost("/api/v1/public/contract-cancellations/resolve", parsePublicContractCancellationResolveRequest({ token })));
}

export async function confirmPublicContractCancellation(token: string, expectedConfirmationFingerprint: string): Promise<PublicContractCancellationConfirmResponseDto> {
  return parsePublicContractCancellationConfirmResponse(await apiPost("/api/v1/public/contract-cancellations/confirm", parsePublicContractCancellationConfirmRequest({ token, expectedConfirmationFingerprint })));
}
export async function previewAdminContractCancellationRevocation(tenantSlug: string, cancellationRequestId: string): Promise<AdminContractCancellationRevocationPreviewDto> { return parseAdminContractCancellationRevocationPreviewResponse(await apiPost(`/api/v1/admin/tenants/${tenantSlug}/contract-cancellations/${cancellationRequestId}/revocation-preview`, {})); }
export async function requestAdminContractCancellationRevocation(tenantSlug: string, cancellationRequestId: string, request: AdminContractCancellationRevocationCreateRequestDto): Promise<AdminContractCancellationRevocationCreateResponseDto> { return parseAdminContractCancellationRevocationCreateResponse(await apiPost(`/api/v1/admin/tenants/${tenantSlug}/contract-cancellations/${cancellationRequestId}/revocations`, parseAdminContractCancellationRevocationCreateRequest(request))); }
export async function resolvePublicContractCancellationRevocation(token: string): Promise<PublicContractCancellationRevocationResolveResponseDto> { return parsePublicContractCancellationRevocationResolveResponse(await apiPost("/api/v1/public/contract-cancellation-revocations/resolve", parsePublicContractCancellationRevocationResolveRequest({ token }))); }
export async function confirmPublicContractCancellationRevocation(token: string, expectedConfirmationFingerprint: string): Promise<PublicContractCancellationRevocationConfirmResponseDto> { return parsePublicContractCancellationRevocationConfirmResponse(await apiPost("/api/v1/public/contract-cancellation-revocations/confirm", parsePublicContractCancellationRevocationConfirmRequest({ token, expectedConfirmationFingerprint }))); }

export async function requestAdminContractEmailChange(
  tenantSlug: string,
  request: ContractEmailChangeRequestDto
): Promise<ContractEmailChangeCreateResponseDto> {
  const parsedRequest = parseContractEmailChangeRequest(request);
  const response = await apiPost<ContractEmailChangeRequestDto, unknown>(
    `/api/v1/admin/tenants/${tenantSlug}/contract-email-changes`,
    parsedRequest
  );
  return parseContractEmailChangeCreateResponse(response);
}

export async function resolvePublicContractEmailChange(
  token: string
): Promise<PublicContractEmailChangeResolveResponseDto> {
  const request = parsePublicContractEmailChangeResolveRequest({ token });
  const response = await apiPost<typeof request, unknown>("/api/v1/public/contract-email-changes/resolve", request);
  return parsePublicContractEmailChangeResolveResponse(response);
}

export async function confirmPublicContractEmailChangeCurrent(
  token: string
): Promise<PublicContractEmailChangeConfirmResponseDto> {
  const request = parsePublicContractEmailChangeConfirmRequest({ token });
  const response = await apiPost<typeof request, unknown>(
    "/api/v1/public/contract-email-changes/confirm-current",
    request
  );
  return parsePublicContractEmailChangeConfirmResponse(response);
}

export async function confirmPublicContractEmailChangeNew(
  token: string
): Promise<PublicContractEmailChangeConfirmResponseDto> {
  const request = parsePublicContractEmailChangeConfirmRequest({ token });
  const response = await apiPost<typeof request, unknown>(
    "/api/v1/public/contract-email-changes/confirm-new",
    request
  );
  return parsePublicContractEmailChangeConfirmResponse(response);
}
